import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDragExit } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CourseManagementService } from "../course-management.service"
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";

@Component({
  selector: 'app-edit-course-detail',
  templateUrl: './edit-course-detail.component.html',
  styleUrls: ['./edit-course-detail.component.scss']
})

export class EditCourseDetailComponent implements OnInit {

  courseDetailForm: FormGroup;
  formSubmitted: boolean = false;
  showLessonError: boolean = true;
  showWeekError: boolean = true;
  showAdditionalError: boolean = true;
  isDisabled: boolean = true;


  selectedFile: any;
  uploadcourseImage: any;
  lessonId: string;
  courseId: string;
  courseDetailReq = {
    lessonId: null,
    title: null,
    weekLabel: null,
    week: null,
    imageUrl: null,
    videoUrl: null,
    thumbnailUrl: null,
    sortOrder: null,
    description: null,
    lessonTopics: [],
    weeksActionSteps: [],
    additionalResources: []
  }
  courseDetail: any;
  lessonTopicList = [];
  weeksActionStepList = [];
  additonalResourseList = [];
  uploadCourseImage: any;
  typelist = [
    { value: 'normal', viewValue: 'Normal' },
    { value: 'webview', viewValue: 'Web View' },
    { value: 'webdoc', viewValue: 'Doc View' },
  ];
  imageUpload: boolean = false;
  ImageUpload: boolean = false;
  showImageError: boolean = true;

  thumpImage: string;
  uploadthumpImage: Boolean = false;
  showthumpImageError: Boolean = true;
  ImagethumpUpload: boolean = false;



  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
    { id: "Block", name: "Block" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  feature: string;
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService) { }

  ngOnInit() {

    this.courseId = this.route.snapshot.params["course_Id"];
    this.route.queryParams.subscribe(param => {
      this.lessonId = param['lessonId'];
    });

    this.initialiseForms();
    this.getlessionById();
  }




  initialiseForms() {
    this.courseDetailForm = this.fb.group({
      title: ["", [Validators.required]],
      weekLabel: ["", [Validators.required]],
      week: ["", [Validators.required]],
      imageUrl: [, [Validators]],
      videoUrl: [, [Validators.required]],
      thumbnailUrl: [, [Validators]],
      sortOrder: [, [Validators.required]],
      description: [, [Validators.required]],
      lessonDescription: [, [Validators]],
      weekDescription: [, [Validators]],
      additionalDescrption: [, [Validators]],
      additionalType: [, [Validators]],
      additionalWebViewUrl: [, [Validators]],
      additionaltitle: [, [Validators]],
    });
  }


  filmCount = 2;
  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };



  getlessionById() {
    let query = this.courseId + "?lessonId=" + this.lessonId;
    this.CourseManagementService.getlessonListById(query).subscribe(res => {
      if (res["message"] === "Success") {
        this.courseDetail = res.data;
        this.updateForm();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });

  }

  updateForm() {
    this.courseDetailForm.patchValue({
      title: this.courseDetail["title"],
      weekLabel: this.courseDetail["weekLabel"],
      week: this.courseDetail["week"],
      imageUrl: this.courseDetail["imageUrl"],
      videoUrl: this.courseDetail["videoUrl"],
      sortOrder: this.courseDetail["week"],
      description: this.courseDetail["description"],
    });
    this.uploadCourseImage = this.courseDetail["imageUrl"];
    this.imageUpload = true;
    this.showImageError = false;
    this.ImageUpload = true;
    this.courseDetailReq.imageUrl = this.courseDetail["imageUrl"];


    this.thumpImage = this.courseDetail["thumbnailUrl"];
    this.uploadthumpImage = true;
    this.showthumpImageError = false;
    this.ImagethumpUpload = true;
    this.courseDetailReq.thumbnailUrl = this.courseDetail["thumbnailUrl"];


    this.courseDetail.lessonTopics.forEach((element) => {
      this.lessonTopicList.push(element.description);

    });
    let length = this.lessonTopicList.length;
    if (length > 0) {
      this.showLessonError = false;
    }
    this.courseDetail.weeksActionSteps.forEach((element) => {
      this.weeksActionStepList.push(element.description);
      this.showWeekError = false;
    });

    length = this.weeksActionStepList.length;
    if (length > 0) {
      this.showLessonError = false;
    }
    this.additonalResourseList = this.courseDetail.additionalResources;
    this.showAdditionalError = false;
  }

  AddLesson() {
    this.lessonTopicList.push(this.courseDetailForm.value.lessonDescription.trim())
    if (this.lessonTopicList.length > 0) {
      this.showLessonError = false;
      this.courseDetailForm.controls['lessonDescription'].setValue(" ");
    }
  }
  addWeekStep() {
    this.weeksActionStepList.push(this.courseDetailForm.value.weekDescription.trim())
    if (this.weeksActionStepList.length > 0) {
      this.showWeekError = false;
      this.courseDetailForm.controls['weekDescription'].setValue(" ");
    }
  }
  resetLession() {
    this.lessonTopicList = [];
    this.courseDetailForm.controls['lessonDescription'].setValue(" ");
    this.showLessonError = true;
  }
  
  resetWeek() {
    this.weeksActionStepList = [];
    this.courseDetailForm.controls['weekDescription'].setValue(" ");
    this.showWeekError = true;
  }

  resetAdditional() {
    this.additonalResourseList = [];
    this.courseDetailForm.controls['weekDescription'].setValue(" ");
    this.showWeekError = true;
  }
 
  resetLessionSingle(index) {
    this.lessonTopicList.splice(index, 1);
  }
  resetWeekSingle(index) {
    this.weeksActionStepList.splice(index, 1);
  }
  resetAdditionalSingle(index) {
    this.additonalResourseList.splice(index, 1);
  }
  dropAdditional(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {

      let tempValue = this.additonalResourseList[event.currentIndex];
      this.courseDetailForm.controls['additionalDescrption'].setValue(tempValue.description);
      this.courseDetailForm.controls['additionalType'].setValue(tempValue.type);
      this.courseDetailForm.controls['additionalWebViewUrl'].setValue(tempValue.webViewUrl);
      this.courseDetailForm.controls['additionaltitle'].setValue(tempValue.title);
      this.additonalResourseList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.additonalResourseList, event.previousIndex, event.currentIndex);

  }
  droplesson(event: CdkDragDrop<string[]>) {

    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      let tempValue = this.lessonTopicList[event.currentIndex];
      this.courseDetailForm.controls['lessonDescription'].setValue(tempValue);
      this.lessonTopicList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.lessonTopicList, event.previousIndex, event.currentIndex);

  }
  dropweekstep(event: CdkDragDrop<string[]>) {
    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      let tempValue = this.weeksActionStepList[event.currentIndex];
      this.courseDetailForm.controls['weekDescription'].setValue(tempValue);
      this.weeksActionStepList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.weeksActionStepList, event.previousIndex, event.currentIndex);
  }

  addAdditional() {
    let url = this.courseDetailForm.value.additionalWebViewUrl.trim();
    if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    this.additonalResourseList.push({ description: this.courseDetailForm.value.additionalDescrption.trim(), title: this.courseDetailForm.value.additionaltitle.trim(), type: this.courseDetailForm.value.additionalType, webViewUrl: url })
    if (this.additonalResourseList.length > 0) {
      this.showAdditionalError = false;
      this.courseDetailForm.controls['additionalDescrption'].setValue(" ");
      this.courseDetailForm.controls['additionalType'].setValue(" ");
      this.courseDetailForm.controls['additionalWebViewUrl'].setValue(" ");
      this.courseDetailForm.controls['additionalDescrption'].setValue(" ");
      this.courseDetailForm.controls['additionaltitle'].setValue(" ");
    }

  }


  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.uploadCourseImage = this.selectedFile.name;
    this.spinner.show();
    this.CourseManagementService.uploadImage(this.selectedFile).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseDetailReq.imageUrl = data.data.fileUrl;
        this.uploadCourseImage = data.data.fileUrl;
        this.imageUpload = true;
        this.showImageError = false;
        this.ImageUpload = true;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }

  onFileChangedthump(event) {
    this.selectedFile = event.target.files[0];
    this.uploadCourseImage = this.selectedFile.name;
    this.spinner.show();
    this.CourseManagementService.uploadImage(this.selectedFile).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseDetailReq.thumbnailUrl = data.data.fileUrl;
        this.thumpImage = data.data.fileUrl;
        this.showthumpImageError = false;
        this.ImagethumpUpload = true;
        this.spinner.hide();



      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }

  onVideoFileChanged(event) {
    const file = event.target.files[0];
    const allowedTypes = ['video/mp4', 'video/webm', 'video/ogg'];
    if (file && !allowedTypes.includes(file.type)) {
      Swal.fire("Error", "Please select a valid video file (MP4, WEBM, or OGG)", "error");
      return;
    }
    if (file) {
      this.spinner.show();
      this.CourseManagementService.uploadVideo(file).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Video uploaded successfully!", "success");
          this.courseDetailForm.controls['videoUrl'].setValue(data.data.fileUrl);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, error => {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Something went wrong while uploading video"
        });
      });
    }
  }
  updateCourseDetail() {
    let lesson = [];
    let weekAction = [];
    let additional = [];
    this.formSubmitted = true;


    if (this.courseDetailForm.valid) {

      this.lessonTopicList.forEach((element, index) => {
        lesson.push({ description: element, sortOrder: index });
        this.courseDetailReq.lessonTopics = lesson;
      });

      this.weeksActionStepList.forEach((element, index) => {
        weekAction.push({ description: element, sortOrder: index });
        this.courseDetailReq.weeksActionSteps = weekAction;
      });
      this.additonalResourseList.forEach((element, index) => {
        additional.push({ description: element.description, sortOrder: index, title: element.title, webViewUrl: element.webViewUrl, type: element.type });
        this.courseDetailReq.additionalResources = additional;
      });

      this.courseDetailReq.lessonId = this.lessonId;
      this.courseDetailReq.title = this.courseDetailForm.value.title;
      this.courseDetailReq.week = this.courseDetailForm.value.week;
      this.courseDetailReq.weekLabel = this.courseDetailForm.value.weekLabel;
      let vUrl = this.courseDetailForm.value.videoUrl ? this.courseDetailForm.value.videoUrl.trim() : null;
      if (vUrl && !vUrl.startsWith('http://') && !vUrl.startsWith('https://')) {
        vUrl = 'https://' + vUrl;
      }
      this.courseDetailReq.videoUrl = vUrl;
      this.courseDetailReq.description = this.courseDetailForm.value.description;
      this.courseDetailReq.sortOrder = this.courseDetailForm.value.sortOrder;
      // this.courseDetailReq.thumbnailUrl = this.courseDetailForm.value.thumbnailUrl;
      this.CourseManagementService.updateLessonById(this.courseDetailReq).subscribe(data => {
        if (data["message"] === "Success") {
          Swal.fire("Success", "Lesson Updated successfully!", "success");
          this.router.navigate(['main/course-management/view-lesson/', this.courseId]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });

    }


  }
  cancel() {
    this.router.navigate(['main/course-management/view-lesson/', this.courseId]);
  }

}
